import { Button, Dialog, DialogContent, DialogDescription, DialogTitle, ImportantNote } from "@/components/ui";

interface ConfirmationDialogProps {
  open: boolean;
  isPending: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export function ConfirmationDialog({ open, isPending, onClose, onConfirm }: ConfirmationDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogTitle className="hidden">Confirm Job creation</DialogTitle>
      <DialogDescription className="hidden">
        Review and accept the terms of service before creating your job
      </DialogDescription>
      <DialogContent>
        <div className="md md:max-h-auto flex max-h-[380px]  flex-col overflow-auto">
          <ImportantNote>
            By clicking confirm below, I agree to Stryker Industrial Solutions, LLC's terms of service, and I certify
            the information I provided in connection with this form is true and correct to the best of my knowledge. I
            also understand that any false information or deliberate omissions on this form may subject me to immediate
            termination of all services provided to me by Stryker Industrial Solutions, LLC.
          </ImportantNote>
          <Button disabled={isPending} className="mt-4 self-center" onClick={onConfirm}>
            Confirm
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
